import { useTranslation } from 'next-i18next';
import { FunctionCard, FunctionCards } from './FunctionCards';
export const BizEnterprise = () => {
  const {
    t
  } = useTranslation(['bizLanding']);
  return <section className="px-[16px] py-2xl min-[751px]:px-[24px] min-[1025px]:px-[40px] min-[1025px]:py-3xl" data-sentry-component="BizEnterprise" data-sentry-source-file="BizEnterprise.tsx">
      <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center gap-lg min-[751px]:items-stretch min-[751px]:gap-2xl">
        <h2 className="px-[16px] text-center text-display-sm-extrabold text-default min-[751px]:text-left">
          {t('biz-landing.enterpriseFeatures.title')}
        </h2>
        <FunctionCards topElement={<Function1 />} bottomLeftElement={<Function2 />} bottomRightElement={<Function3 />} data-sentry-element="FunctionCards" data-sentry-source-file="BizEnterprise.tsx" />
      </div>
    </section>;
};
const Function1 = () => {
  const {
    t
  } = useTranslation(['bizLanding']);
  return <FunctionCard.HorizontalWrapper className="bg-blue-50" data-sentry-element="unknown" data-sentry-component="Function1" data-sentry-source-file="BizEnterprise.tsx">
      <div className="flex-1">
        <div className="flex size-full flex-col items-center gap-sm px-lg py-xl min-[751px]:items-stretch min-[751px]:gap-lg min-[751px]:p-2xl min-[751px]:pr-0 min-[1025px]:p-3xl min-[1025px]:pr-0">
          <FunctionCard.Title className="text-blue-900" data-sentry-element="unknown" data-sentry-source-file="BizEnterprise.tsx">
            {t('biz-landing.enterpriseFeature1.title')}
          </FunctionCard.Title>
          <FunctionCard.Description data-sentry-element="unknown" data-sentry-source-file="BizEnterprise.tsx">
            {t('biz-landing.enterpriseFeature1.content')}
          </FunctionCard.Description>
        </div>
      </div>

      <div className="flex-1 min-[751px]:h-[310px] min-[1025px]:h-[374px]">
        <img src={'/assets/biz-landing/enterprise/enterprise-image1.webp'} alt="Logo custom branding" className="size-full min-[751px]:object-cover min-[751px]:object-left" />
      </div>
    </FunctionCard.HorizontalWrapper>;
};
const Function2 = () => {
  const {
    t
  } = useTranslation(['bizLanding']);
  return <FunctionCard.VerticalWrapper className="bg-blue-100" data-sentry-element="unknown" data-sentry-component="Function2" data-sentry-source-file="BizEnterprise.tsx">
      <div className="flex flex-col items-center gap-sm px-lg py-xl min-[751px]:items-stretch min-[751px]:gap-lg min-[751px]:p-2xl min-[751px]:pb-0 min-[1025px]:p-3xl min-[1025px]:pb-0">
        <div className="flex flex-col items-center gap-md min-[751px]:items-stretch">
          <FunctionCard.Title className="text-blue-900" data-sentry-element="unknown" data-sentry-source-file="BizEnterprise.tsx">
            {t('biz-landing.enterpriseFeature2.title')}
          </FunctionCard.Title>
        </div>
        <FunctionCard.Description data-sentry-element="unknown" data-sentry-source-file="BizEnterprise.tsx">
          {t('biz-landing.enterpriseFeature2.content')}
        </FunctionCard.Description>
      </div>

      <img src={'/assets/biz-landing/enterprise/enterprise-image2.webp'} alt="Maximum 1,000 concurrent access" />
    </FunctionCard.VerticalWrapper>;
};

// TODO: Replace with actual biz landing images

const Function3 = () => {
  const {
    t
  } = useTranslation(['bizLanding']);
  return <FunctionCard.VerticalWrapper className="bg-[#EEF5FA]" data-sentry-element="unknown" data-sentry-component="Function3" data-sentry-source-file="BizEnterprise.tsx">
      <div className="flex flex-col items-center gap-sm px-lg py-xl min-[751px]:items-stretch min-[751px]:gap-lg min-[751px]:p-2xl min-[751px]:pb-0 min-[1025px]:p-3xl min-[1025px]:pb-0">
        <FunctionCard.Title className="text-blue-900" data-sentry-element="unknown" data-sentry-source-file="BizEnterprise.tsx">
          {t('biz-landing.enterpriseFeature3.title')}
        </FunctionCard.Title>
        <FunctionCard.Description data-sentry-element="unknown" data-sentry-source-file="BizEnterprise.tsx">
          {t('biz-landing.enterpriseFeature3.content')}
        </FunctionCard.Description>
      </div>

      <img src={'/assets/biz-landing/enterprise/enterprise-image3.webp'} alt="Dedicated CS and monitoring" />
    </FunctionCard.VerticalWrapper>;
};